// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top-time[data-v-8389e786]{display:flex;padding:.53333rem}.top-time>div[data-v-8389e786]{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center}.top-time>div>span[data-v-8389e786]{font-family:Inter-Regular}.top-time>div>span[data-v-8389e786]:first-child{font-size:.64rem;font-weight:600;color:#fff;line-height:.88rem}.top-time>div>span[data-v-8389e786]:nth-child(2){font-weight:400;font-size:.42667rem;color:hsla(0,0%,100%,.6)}", ""]);
// Exports
module.exports = exports;
